<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
        v-for="(item, index) in levelList"
        :key="item.path"
        v-if="item.meta.title"
      >
        <span
          v-if="item.redirect === 'noredirect' || index == levelList.length - 1"
          class="no-redirect"
          >{{ item.meta.title
          }}{{
            item.meta.title == "药品订单" ? "：" + total + "单" : ""
          }}</span>
        <router-link v-else :to="item.redirect || item.path">{{
          item.meta.title
        }}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { mapState } from "vuex";
export default {
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      levelList: null,
      totalCount: this.$store.state.user.totalCount,
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
   computed: {
    ...mapState({
      total: (state) => state.user.allnum,
    }),
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name);
      const first = matched[0];
      // if (first && first.name !== 'home') {
      //   matched = [{ path: '/dashboard', meta: { title: '首页' }}].concat(matched)
      // }
      this.levelList = matched;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue